var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTagLibre = function SvgTagLibre(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "tag_libre_svg__Capa_2",
    viewBox: "0 0 16 15.33"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "tag_libre_svg__Capa_1-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.65 14.02c-.16.91.8 1.61 1.62 1.18L8 13.24l3.73 1.96c.82.43 1.78-.27 1.62-1.18l-.71-4.16 3.02-2.94c.66-.65.3-1.77-.62-1.91h-.07L3 11.96z",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.87 4.4 9 .62c-.41-.83-1.59-.83-2 0L5.13 4.4l-4.17.61C.04 5.14-.32 6.27.34 6.92l3.02 2.94-.02.12 9.18-5.33-1.65-.24Z",
    fill: "#b3b3b3"
  }))));
};
export default SvgTagLibre;